import type { ComponentProps } from 'react';
import { BottomBar } from './BottomBar';
import { BgBlurredText } from './BgBlurredText';
import { Contents } from './Contents';
import { ProductWizard } from 'components/shared/ProductWizard';
import { TechnicalSpecs } from './TechnicalSpecs';
import { SolidBgTextSection } from './SolidBgTextSection';
import { Capabilities } from 'components/ring-air/Capabilities';
import { FAQSection } from 'components/shared/FAQSection';

export * from './ProductSelectionSection';
export * from './BottomBar';

export const PageContent = ({
  faqData,
  wizardTitle,
}: {
  faqData: ComponentProps<typeof FAQSection>['faqData'];
  wizardTitle: string;
}) => (
  <>
    <Contents />
    <BgBlurredText />
    <TechnicalSpecs imageBackgroundColor="#ffffff" />
    <SolidBgTextSection />
    <Capabilities />
    <ProductWizard title={wizardTitle} />
    <FAQSection faqData={faqData} />
    <BottomBar />
  </>
);
